import { useEffect, useState } from 'react';
import { getPortalUser } from '../auth/portalSession';

/** Allow Cognito admin or support (FORE helpdesk). */
export async function currentUserIsAdminOrSupport() {
  try {
    const user = await getPortalUser();
    const groups =
      user?.signInUserSession?.accessToken?.payload?.['cognito:groups'] || [];
    if (!Array.isArray(groups)) return groups === 'admin' || groups === 'support';
    return groups.includes('admin') || groups.includes('support');
  } catch (e) {
    return false;
  }
}

export default function SupportOrAdminRoute({ children }) {
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const ok = await currentUserIsAdminOrSupport();
      if (!cancelled) setAllowed(ok);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (allowed === null) return null;
  if (!allowed) {
    return (
      <div style={{ padding: '1rem' }}>
        Support or admin access required for Combine accounts.
      </div>
    );
  }
  return children;
}
